import { LineItem, LineItemRecord, Order } from "@/models/order/order";
import { DriftReport } from "@/models/quote_draft/quote_draft";
import { OrderState } from "./types";

export const getOrder = (state: OrderState): Order => {
  return state;
};

export const getOrderItems = (state: OrderState): LineItem[] | undefined => {
  return state.items;
};

export const getAssignedCustomer = (state: OrderState): string | undefined => {
  return state.customer_name;
};

export const getDriftReport = (
  state: OrderState
): DriftReport | null | undefined => {
  return state.drift_report;
};
